// src/components/General/Avatar.js
import React from "react";

const getUserProfile = (rawName = "User") => {
  // -----------------------------
  // 1. Name cleanup + initials
  // -----------------------------
  let displayName = rawName;
  let initials = "U";

  const nameMatch = rawName.match(/^([^,]+),\s*([^(]+)\s*(\(.*\))?$/);
  if (nameMatch) {
    const last = nameMatch[1].trim();
    const first = nameMatch[2].trim();
    const org = nameMatch[3]?.trim() || "";

    displayName = `${first}, ${last} ${org}`.trim();
    initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
  }

  // Trimmed display name
  const maxNameLength = 25;
  const trimmedName =
    displayName.length > maxNameLength
      ? displayName.slice(0, maxNameLength - 3) + "..."
      : displayName;

  // -----------------------------
  // 2. Avatar generation
  // -----------------------------
  const colors = [
    "#dcedc8", "#c8e6ff", "#ffe0b2", "#e1bee7",
    "#c8e6c9", "#ffcdd2", "#bbdefb", "#f0f4c3",
    "#d1c4e9", "#b2dfdb",
  ];

  let hash = 0;
  for (let i = 0; i < initials.length; i++) {
    hash = (hash * 31 + initials.charCodeAt(i)) >>> 0;
  }
  const bg = colors[hash % colors.length];

  const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
  <rect width="64" height="64" fill="${bg}" />
  <text x="50%" y="50%"
    text-anchor="middle"
    dominant-baseline="middle"
    font-size="28"
    font-weight="400"
    fill="#000"
    font-family="-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif">
    ${initials}
  </text>
</svg>`.trim();

  const avatar = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;

  return {
    trimmedName,
    avatar,
  };
};

export default getUserProfile;
